module.exports = __webpack_public_path__ + "img/button_my.4b94b11d.png";